import React from 'react'

import { Link } from 'react-router-dom'

const LINKS = [
  {
    title:
      'Knowledgeable Coexistence as a Key for Christian - Muslim Relations in the Near East – Experiences form the Project ‘Recalled Future’',
    subtitle: '',
    author: 'Thomas Würtz',
    url: 'http://erinnerte-zukunft.de/EBU_22.pdf'
  },
  {
    title: 'Niklaus von Flüe. Mystiker, Mittler, Mensch',
    subtitle: '',
    author: 'Rifa´at Lenzin',
    url: 'http://erinnerte-zukunft.de/Rifaat_Lenzin_Mystiker_Mittler_Mensch.pdf'
  },
  {
    title: 'Konferenz Healing of Memories in Göteborg',
    subtitle: 'Schwedischer Konferenzbericht mit Projektvorstellung',
    author: 'Tomas Pettersson',
    url: 'http://erinnerte-zukunft.de/healing_of_memories.pdf'
  },
  {
    title: 'Konferenz Healing of Memories in Göteborg',
    subtitle: 'Deutsche Übersetzung des Abschnitts über „Erinnerte Zukunft“',
    author: 'Angelika Salomon',
    url:
      'http://erinnerte-zukunft.de/Deutsche_Uebersetzung_Healing_of_memories.pdf'
  },
  {
    title: 'Vom Wert geschichtlichen Wissens',
    subtitle: 'Für eine verantwortungsbewusste Flüchtlingspolitik',
    author: 'Thomas Würtz',
    url: 'http://erinnerte-zukunft.de/Beitrag_Wuertz_Fluchtursachen.pdf'
  },
  {
    title: 'Das interreligiöse Gebet —<br/> eine Möglichkeit nach Laudato Si?',
    subtitle: '',
    author: 'Schwester Margareta Gruber',
    url:
      'http://weltkirche.katholisch.de/Themen/Interreligi%C3%B6ser-Dialog/Interreligioeses-Gebet'
  },
  {
    title: '„Kirche des Islam“',
    subtitle: 'Zur Theologie Paolo Dall‘Oglios',
    author: 'Eva-Maria Lika',
    url: 'http://erinnerte-zukunft.de/Eva_Maria_Lika_Kirche_des_Islam.pdf'
  },
  {
    title: 'Wer glaubt ist ein Flüchtling',
    subtitle: 'Morgenandacht im Deutschlandfunk',
    author: 'Pfarrerin Sandra Zeidler aus München',
    url:
      'http://static.evangelisch.de/get/?daid=q50L5TkLyxCLp5IDmQ2vvzHl00098683&dfid=download'
  },
  {
    title: 'Das Dialogverständnis der katholischen Kirche',
    subtitle: '',
    author: 'Felix Körner SJ',
    url:
      'http://erinnerte-zukunft.de/01_Das_Dialogverstaendnis_der_katholischen_Kirche.pdf'
  },
  {
    title: 'Tiefgang, Offenheit, Profil.',
    subtitle: 'Zum Verhältnis von Dialog und Mission',
    author: 'Felix Körner SJ',
    url: 'http://erinnerte-zukunft.de/02_Tiefgang_Offenheit_Profil.pdf'
  },
  {
    title: 'Jeder nach seiner Facon',
    subtitle: 'Die Entwicklung der religiösen Vielfalt in und um Berlin',
    author: 'Gerdi Nützel',
    url: 'http://erinnerte-zukunft.de/03_Jeder_nach_seiner_Facon.pdf'
  },
  {
    title: 'Erinnerte Zukunft',
    subtitle: 'Die Idee',
    author: 'Thomas Würtz',
    url: '/die_idee',
    internal: true
  },
  {
    title: 'Der Ablauf des Projekts',
    subtitle: '',
    author: 'Thomas Würtz',
    url: 'http://erinnerte-zukunft.de/Erinnerte_Zukunft_Plan.pdf'
  },
  {
    title: 'Wiedersehenstreffen im Februar 2019',
    subtitle: '',
    author: 'Thomas Würtz',
    url: 'http://erinnerte-zukunft.de/Wiedersehenstreffen_EZ_02_19.pdf'
  }
]

const LINKS_PRESS = [
  {
    title: '„Erinnerte Zukunft“ sagt Danke!',
    subtitle: '',
    author: 'Thomas Würtz',
    url: 'http://erinnerte-zukunft.de/Pfarrnachrichten_2018.pdf'
  },
  {
    title: 'Erinnerte Zukunft',
    subtitle:
      'Die Nachbarschaft der Religionen im Nahen Osten soll bewahrt werden',
    author: 'Thomas Würtz',
    url:
      'http://erinnerte-zukunft.de/Wuertz_2018_Bericht_Erinnerte_Zukunft_Cibedo_Beitrage.pdf'
  },
  {
    title: 'START-UPS des Glaubens',
    subtitle:
      'Erfahrungsberichte aus der Personalstellenförderung des Bonifatiuswerkes',
    author: '',
    url: 'http://erinnerte-zukunft.de/Startups_des_Glaubens.pdf'
  },
  {
    title: 'Bewahren was es schon eimal gab',
    subtitle:
      'Ein friedliches Zusammenleben von Christen und Muslimen aus dem Nahen Osten.',
    author: 'Cornelia Klaebe',
    url: 'http://erinnerte-zukunft.de/Bewahren_was_es_schon_einmal_gab.pdf'
  },
  {
    title: 'Mit Religion gegen Religionskriege?',
    subtitle: '',
    author: 'Manfred Götzke',
    url:
      'http://www.deutschlandfunk.de/syrien-fluechtlinge-mit-religion-gegen-religionskriege.886.de.html?dram:article_id=408911'
  },
  {
    title: 'Das Konzept des dritten Orts',
    subtitle: '',
    author: 'Claudia Mende',
    url:
      'https://www.welt-sichten.org/artikel/33313/das-konzept-des-dritten-orts'
  },
  {
    title: 'Mit Religion gegen Religionskriege',
    subtitle: '',
    author: 'Susanne Kaiser',
    url:
      'https://de.qantara.de/inhalt/interreligioeses-projekt-erinnerte-zukunft-mit-religion-gegen-religionskriege'
  }
]

export default function Material() {
  return (
    <section id="material" className="material--background">
      <div className="material">
        <h3 className="material-title">Pressestimmen</h3>
        {LINKS_PRESS.map((entry, i) => {
          return <MaterialEntry key={i} entry={entry} isPress={true} />
        })}
        <h3 className="material-title material-title--second">
          Material zum Thema
        </h3>
        {LINKS.map((entry, i) => {
          return <MaterialEntry key={i} entry={entry} isPress={false} />
        })}
      </div>
    </section>
  )
}

function MaterialEntry(props) {
  let link = (
    <Link className="material-entry-link" to={props.entry.url}>
      {' '}
      Lesen
    </Link>
  )
  if (!props.entry.internal) {
    link = (
      <a className="material-entry-link" href={props.entry.url}>
        Lesen
      </a>
    )
  }
  return (
    <div
      className={
        'material-entry material-entry--' + (props.isPress ? 'press' : 'theme')
      }
    >
      <div
        className="material-entry-title"
        dangerouslySetInnerHTML={{ __html: props.entry.title }}
      />
      <div className="material-entry-subtitle">{props.entry.subtitle}</div>
      <div className="material-entry-author">
        {(props.entry.author !== '' ? 'von ' : '') + props.entry.author}
      </div>
      {link}
      <hr className="material-entry-seperator" />
    </div>
  )
}



/** WEBPACK FOOTER **
 ** ./src/components/material.js
 **/